/** Fuel price helpers for invoice creation (base price + per-gallon margin). */

export function parseFuelMargin(value) {
  const n = parseFloat(value);
  return Number.isFinite(n) && n >= 0 ? n : 0;
}

export function effectiveFuelPricePerGallon(basePrice, margin) {
  return (parseFloat(basePrice) || 0) + parseFuelMargin(margin);
}

export function getFuelMarginsFromForm(formData) {
  return {
    diesel: parseFuelMargin(formData?.diesel_fuel_margin),
    def: parseFuelMargin(formData?.def_fuel_margin),
    dyed: parseFuelMargin(formData?.dyed_fuel_margin),
  };
}

/** Return pricing row with margins added to each fuel unit price. */
export function applyFuelMarginsToPricing(pricing, margins) {
  if (!pricing) return null;
  return {
    ...pricing,
    diesel_price_per_liter: effectiveFuelPricePerGallon(
      pricing.diesel_price_per_liter,
      margins.diesel
    ),
    def_price_per_liter: effectiveFuelPricePerGallon(pricing.def_price_per_liter, margins.def),
    dyed_price_per_liter: effectiveFuelPricePerGallon(
      pricing.dyed_price_per_liter,
      margins.dyed
    ),
  };
}
